import { render } from "./recordPage.vue?vue&type=template&id=db9efd44&scoped=true"
import script from "./recordPage.vue?vue&type=script&lang=js"
export * from "./recordPage.vue?vue&type=script&lang=js"

import "./recordPage.vue?vue&type=style&index=0&id=db9efd44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db9efd44"]])

export default __exports__